import useApi from 'Lib/hooks/useApi';

import AsyncFilter from './AsyncFilter';

export default function Tag(props) {
	const fetchTags = useApi(props.api.searchTags);

	const getOptions = () => {
		return new Promise(resolve => {
			fetchTags({ tagIDs: Array.isArray(props.value) ? props.value : [props.value] }).then(response => {
				const defaults = response.data.map(({ tag }) => ({
					label: tag.name,
					value: tag.tagID
				}));
				resolve(defaults);
			});
		});
	};

	const createOption = item => {
		return { label: item.tag.name, value: item.tag.tagID };
	};

	return (
		<AsyncFilter
			multiple={props.multi}
			value={props.value}
			label={props.label}
			placeholder="Type to search tag"
			optionPath="tag.tagID"
			fetch={fetchTags}
			getDefaultOptions={getOptions}
			createOption={createOption}
			onChange={(__, options) => {
				let selected = options;
				if (options) selected = Array.isArray(options) ? options.map(option => option.value) : [options.value];
				props.onChange(props.name, selected);
			}}
		/>
	);
}
